document.addEventListener('DOMContentLoaded', function () {
  try {
    // Nav scroll shadow
    var navbar = document.getElementById('navbar');
    if (navbar) {
      window.addEventListener('scroll', function () {
        try {
          navbar.classList.toggle('scrolled', window.scrollY > 20);
        } catch(e) {}
      });
    }

    // Mobile menu toggle
    var toggle = document.querySelector('.nav-mobile-toggle');
    var mobileMenu = document.getElementById('mobileMenu');
    if (toggle && mobileMenu) {
      toggle.addEventListener('click', function () {
        try {
          mobileMenu.classList.toggle('open');
        } catch(e) {}
      });
    }

    // Close mobile menu when clicking outside
    document.addEventListener('click', function(e) {
      try {
        if (mobileMenu && toggle && !mobileMenu.contains(e.target) && !toggle.contains(e.target)) {
          mobileMenu.classList.remove('open');
        }
      } catch(e) {}
    });

    // Scroll reveal - only if IntersectionObserver is supported
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          try {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
            }
          } catch(e) {}
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

      document.querySelectorAll('.reveal').forEach(function (el) {
        try {
          observer.observe(el);
        } catch(e) {}
      });
    } else {
      // Fallback: just make everything visible
      document.querySelectorAll('.reveal').forEach(function (el) {
        el.classList.add('visible');
      });
    }

  } catch(e) {
    // If anything fails, make all reveal elements visible so page still works
    try {
      document.querySelectorAll('.reveal').forEach(function (el) {
        el.classList.add('visible');
      });
    } catch(e2) {}
  }
});
